$(document).ready(function() {
      $('.custom_slider_outer').slick({
      dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
 infinite: true,
     prevArrow:'<button class="custom_test_arrow prev-arrrow slider-button slider-button--prev"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M6.08516 13.0669L0.468489 7.46693C0.401823 7.40026 0.354712 7.32804 0.327156 7.25026C0.299156 7.17248 0.285156 7.08915 0.285156 7.00026C0.285156 6.91137 0.299156 6.82804 0.327156 6.75026C0.354712 6.67248 0.401823 6.60026 0.468489 6.53359L6.08516 0.916927C6.24071 0.761371 6.43516 0.683594 6.66849 0.683594C6.90182 0.683594 7.10182 0.766927 7.26849 0.933594C7.43516 1.10026 7.51849 1.2947 7.51849 1.51693C7.51849 1.73915 7.43516 1.93359 7.26849 2.10026L2.36849 7.00026L7.26849 11.9003C7.42404 12.0558 7.50182 12.2474 7.50182 12.4749C7.50182 12.7029 7.41849 12.9003 7.25182 13.0669C7.08516 13.2336 6.89071 13.3169 6.66849 13.3169C6.44627 13.3169 6.25182 13.2336 6.08516 13.0669Z" fill="#BFBFBF"/></svg></button>',
    nextArrow:'<button class="custom_test_arrow next-arrrow slider-button slider-button--next"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1.91484 13.0669L7.53151 7.46693C7.59818 7.40026 7.64529 7.32804 7.67284 7.25026C7.70084 7.17248 7.71484 7.08915 7.71484 7.00026C7.71484 6.91137 7.70084 6.82804 7.67284 6.75026C7.64529 6.67248 7.59818 6.60026 7.53151 6.53359L1.91484 0.916927C1.75929 0.761371 1.56484 0.683594 1.33151 0.683594C1.09818 0.683594 0.898178 0.766927 0.731511 0.933594C0.564845 1.10026 0.481511 1.2947 0.481511 1.51693C0.481511 1.73915 0.564845 1.93359 0.731511 2.10026L5.63151 7.00026L0.731511 11.9003C0.575956 12.0558 0.498178 12.2474 0.498178 12.4749C0.498178 12.7029 0.581511 12.9003 0.748178 13.0669C0.914845 13.2336 1.10929 13.3169 1.33151 13.3169C1.55373 13.3169 1.74818 13.2336 1.91484 13.0669Z" fill="#BFBFBF"/></svg></button>',
    responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
  
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
      ]
});
  $(".product-count.light").appendTo(".product_count_append");

  $(document).on("click",".grid_change_layout span.grid_layout-data",function() {
  $(this).addClass("active");
  $(".grid_change_layout span.list_layout_data").removeClass("active");
$("div#ProductGridContainer").addClass("products-in-grid");
$("div#ProductGridContainer").removeClass("products-in-list");
});
$(document).on("click",".grid_change_layout span.list_layout_data",function() {
  $(this).addClass("active");
  $(".grid_change_layout span.grid_layout-data").removeClass("active");
$("div#ProductGridContainer").removeClass("products-in-grid");
$("div#ProductGridContainer").addClass("products-in-list");
});
   if ($(".custom_pdp_checked input").is(':checked')) {
      $(".product-form").find(".product-form__buttons button").removeAttr("disabled");
       $(".product-form").find(".product-form__buttons .overlay_data").hide();
   }else{
      $(".product-form").find(".product-form__buttons button").attr("disabled","disabled");
      $(".product-form").find(".product-form__buttons .overlay_data").show();
   }
  $(".custom_pdp_checked input").change(function() {
    if ($(this).is(':checked')) {
        $(this).parents(".product-form").find(".product-form__buttons button").removeAttr("disabled");
       $(this).parents(".product-form").find(".product-form__buttons .overlay_data").hide();
       $(this).removeClass("error-come");
    }else{
        $(this).parents(".product-form").find(".product-form__buttons button").attr("disabled","disabled");
      $(this).parents(".product-form").find(".product-form__buttons .overlay_data").show();
    }
});
  $(".overlay_data").click(function() {
     if ($(this).parents(".product-form").find(".custom_pdp_checked input").is(':checked')) {
$(this).parents(".product-form").find(".custom_pdp_checked input").removeClass("error-come");
     }else{
       $(this).parents(".product-form").find(".custom_pdp_checked input").addClass("error-come");
     }
});
});